import { mutatorAction } from "satcheljs";
import { UserStore } from "sh-stores";

export default mutatorAction('SET_DISABLE_CONFLICT_MANAGEMENT_TOGGLE', function setDisableHideConflictManagementToggle(disableHideConflictManagementToggle: boolean) {
    UserStore().disableHideConflictManagementToggle = disableHideConflictManagementToggle;
});
